export default "__VITE_ASSET__VP1oBc4R__"